import { render, staticRenderFns } from "./SmsDispatch.vue?vue&type=template&id=8090f136&scoped=true&"
import script from "./SmsDispatch.vue?vue&type=script&lang=ts&"
export * from "./SmsDispatch.vue?vue&type=script&lang=ts&"
import style0 from "./SmsDispatch.vue?vue&type=style&index=0&id=8090f136&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8090f136",
  null
  
)

export default component.exports